<template>
  <div id="app" ondragstart="return false" onselectstart="return false" @click="gloClick">
    <transition name="fade">
      <div class="loading-main" v-show="isLoading">
        <div class="loader-cycle-disks"></div>
      </div>
    </transition>
    <router-view />
    <DetailedNavigation />
    <BasePopup></BasePopup>
    <SharePopup></SharePopup>
    <PopupDetails v-if="isPicture" :nameOrId="nameOrId" />
  </div>
</template>
<script>
import { queryPreface, queryTopic } from '@/api/http/index'

export default {
  name: '',
  data() {
    return {
      isPicture: false,
      isLoading: false,
      nameOrId: '',
      baseBgShow: true
    }
  },
  created() {},
  mounted() {
    window.pageStack = 0

    this.$EventBus.$on('loadEvent', val => (this.isLoading = val))
    this.$EventBus.$on('hasPopupDetails', val => {
      this.isPicture = true
      this.nameOrId = val
    })

    this.getPartialPageColumnPreface()
    this.getHotWordRecommendation()
    this.getNineKingName()
    this.getGuanSiColumn()
    this.getCemeteryStructure()
  },
  beforeDestroy() {
    this.$EventBus.$off('loadEvent', 'hasPopupDetails')
  },
  components: {},
  computed: {},
  methods: {
    // 全局点击
    gloClick() {
      console.log('全局点击')
      this.$EventBus.$emit('showNav', false)
    },
    // 获取部分页面栏目前言
    getPartialPageColumnPreface() {
      queryPreface('qianyan').then(
        res => {
          if (res) {
            const prefaceObj = {}
            res.childs.forEach(el => (prefaceObj[el.topicNumber] = el))
            localStorage.setItem('columnPreface', JSON.stringify(prefaceObj))
          } else {
            // 错误处理
          }
        },
        () => {
          // 错误处理
        }
      )
    },
    // 获取热词推荐
    getHotWordRecommendation() {
      queryTopic('tuijian').then(res => {
        if (res) {
          const hotWordList = []
          const { instances, relInstances } = res
          instances.forEach(el => {
            relInstances.forEach(el2 => {
              if (el.instanceId === el2.instanceId) {
                let obj = {
                  instanceId: el.instanceId,
                  instanceName: el.instanceName,
                  title: el2.title,
                  conceptCode: el.conceptCode
                }
                hotWordList.push(obj)
              }
            })
          })
          localStorage.setItem('hotWordList', JSON.stringify(hotWordList))
        }
      })
    },
    // 获取九王名称
    getNineKingName() {
      queryTopic('ChuKing').then(res => {
        if (res) {
          const { relInstances } = res
          localStorage.setItem('ChuKing', JSON.stringify(relInstances))
        }
      })
    },
    // 获取土地官司栏目
    getGuanSiColumn() {
      queryTopic('LandLitigation').then(res => {
        if (res) {
          const { relInstances } = res
          localStorage.setItem('LandLitigation', JSON.stringify(relInstances))
        }
      })
    },
    // 获取墓园结构
    getCemeteryStructure() {
      queryPreface('jiegou').then(res => {
        if (res) {
          const { childs } = res
          const JgObj = {}
          childs.forEach(el1 => {
            el1.relInstances.sort((a, b) => a - b)
            let cSlist = []
            let key = el1.topicName.slice(0, -2)
            el1.relInstances.forEach(el2 => {
              const obj = {}
              el1.instances.forEach(el3 => {
                if (el2.instanceId === el3.instanceId) {
                  obj.instanceName = el2.title
                  obj.description = el3.properties.description.replace(/<[^>]+>/g, '')
                }
              })
              cSlist.push(obj)
            })
            JgObj[key] = cSlist
          })
          localStorage.setItem('jiegou', JSON.stringify(JgObj))
        }
      })
    }
  },
  watch: {}
}
</script>
<style lang="scss">
#app {
  position: relative;

  width: 11.7rem;
  height: 100%;

  font-family: 'SiYuan-Regular', '楷体', 'KaiTi', '楷体_GB2312', serif;
  height: 100%;

  .loading-main {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
    border-radius: 0.04rem;
    // margin-left: -0.75rem;
    .loader-cycle-disks {
      position: relative;
      // margin: 0 auto;
      display: flex;
      align-items: center;
      // width: 1.5rem;
      // height: 0.5rem;
      // border-radius: 0.04rem;
      width: 3rem;
      height: 1rem;
      border-radius: 0.1rem;

      background: rgba(255, 255, 255, 0.8);
      justify-content: center;
    }
    .loader-cycle-disks:before,
    .loader-cycle-disks:after {
      content: '';
      position: absolute;

      left: 33%;
      // width: 0.2rem;
      // height: 0.2rem;
      width: 0.47rem;
      height: 0.47rem;
      border-radius: 50%;
      background-color: #bc9a75;
      -webkit-animation: movingCircles 2s infinite ease-in-out;
      animation: movingCircles 2s infinite ease-in-out;

      // transform: translateX(-50%);
    }
    .loader-cycle-disks:after {
      -webkit-animation-delay: -1s;
      animation-delay: -1s;
      background-color: #d15a47;
    }
  }

  @-webkit-keyframes movingCircles {
    0% {
      z-index: 1;
      transform: translate(0, 0);
    }
    50% {
      z-index: 1;
      transform: translate(120%, 0);
    }
    50.1% {
      z-index: 0;
      transform: translate(120%, 0);
    }
    100% {
      z-index: 0;
      transform: translate(0, 0);
    }
  }

  @keyframes movingCircles {
    0% {
      z-index: 1;
      transform: translate(0, 0);
    }
    50% {
      z-index: 1;
      transform: translate(120%, 0);
    }
    50.1% {
      z-index: 0;
      transform: translate(120%, 0);
    }
    100% {
      z-index: 0;
      transform: translate(0, 0);
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

.relationClass {
  width: auto !important;
  max-width: 10rem !important;
  // left: 0 !important;
  // top: 0 !important;
  // border-radius: 0 !important;
  background: rgba(53, 41, 41, 0.8) !important;
  padding-top: 0.2rem !important;
  border: none !important;
  .el-notification__group {
    margin-left: 0.1rem;
    .el-notification__title {
      color: #d15a47 !important;
      font-size: 0.32rem;
    }
    .el-notification__content {
      p {
        color: rgba(255, 255, 255, 0.8) !important;
        font-size: 0.32rem;
        line-height: 0.5rem;
        margin: 0.06rem 0 0;
      }
    }
    .el-notification__closeBtn {
      font-size: 0.4rem;
      top: 0.25rem;
      right: 0.3rem;
    }
  }
}
</style>
